module.exports = __webpack_public_path__ + "static/media/modern2.8f95b39a.jpg";